import * as React from 'react';

import { useGetTestId } from '@/hooks';
import { cn } from '@/lib/utils';

interface InputProps extends React.ComponentProps<'input'> {
  error?: boolean | string; // can be boolean or error message
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, error, ...props }, ref) => {
    const testId = useGetTestId(props.name);

    return (
      <input
        type={type}
        data-testid={testId}
        className={cn(
          'flex h-11 w-full rounded-md border px-3 py-2 text-zink-100 placeholder:text-zink-500 text-base ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm disabled:bg-zinc-700',
          // Default border
          'border-input bg-background focus-visible:ring-ring',
          // Error state
          error &&
            'border-destructive focus-visible:ring-500 focus-visible:ring-red-500',
          className
        )}
        ref={ref}
        {...props}
      />
    );
  }
);

Input.displayName = 'Input';

export { Input };
